import React, { useState, useEffect, useCallback } from 'react'
import './Products.css'
import { useTranslation } from 'react-i18next';

const slides = [
  { src: 'product-slide-1.png', alt: 'Product 1' },
  { src: 'product-slide-2.png', alt: 'Product 2' },
  { src: 'product-slide-3.png', alt: 'Product 3' },
  { src: 'product-slide-4.png', alt: 'Product 4' },
]

const Products = () => {
  const { t } = useTranslation();
  const [current, setCurrent] = useState(0)
  const [animating, setAnimating] = useState(false)

  const goTo = useCallback((index) => {
    if (animating) return
    setAnimating(true)
    setCurrent(index)
    setTimeout(() => setAnimating(false), 600)
  }, [animating])

  const prev = () => goTo((current - 1 + slides.length) % slides.length)
  const next = useCallback(() => goTo((current + 1) % slides.length), [current, goTo])

  // Auto-play every 4 seconds
  useEffect(() => {
    const timer = setInterval(next, 4000)
    return () => clearInterval(timer)
  }, [next])

  return (
    <section id='products'>
      <div className="products-header container-fluid px-md-5 px-3 pt-5">
        <div className="text-center">
          <h6 className='section-title'>{t('products.title')}</h6>
          <h4 className='section-suptitle'>{t('products.subtitle')}</h4>
          <p className='section-desc mx-auto mb-3'>
            {t('products.desc')}
          </p>
        </div>
      </div>

      {/* Fullscreen Slider */}
      <div className="product-slider">
        {slides.map((slide, i) => (
          <div
            key={i}
            className={`product-slide ${i === current ? 'active' : ''}`}
          >
            <img src={slide.src} alt={slide.alt} />
          </div>
        ))}

        {/* Prev / Next arrows */}
        <button className="slider-btn slider-btn--prev" onClick={prev} aria-label="Previous">
          &#8249;
        </button>
        <button className="slider-btn slider-btn--next" onClick={next} aria-label="Next">
          &#8250;
        </button>

      </div>

      {/* Dot indicators — below the slider */}
      <div className="slider-dots">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`slider-dot ${i === current ? 'active' : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </section>
  )
}

export default Products
